/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 状態
 * @export
 * @enum {string}
 */

export const TriggerStatus = {
    Active: 'active',
    Inactive: 'inactive'
} as const;

export type TriggerStatus = typeof TriggerStatus[keyof typeof TriggerStatus];



